// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__C9vZp","text":"Banner_text__tWsZI","content":"Banner_content__5Ke3a","image":"Banner_image__PY5J-"};